module.exports = __webpack_public_path__ + "static/media/partner-fitter.36df5d32.jpg";